module.exports = __webpack_public_path__ + "static/media/background-carousel.7c7d19b8.jpg";